<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2">Project Photos and Documents</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form class="pa-5">
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-select v-model="addData.comments" :items="documentTypes" :item-text="'name'" :item-value="'id'"
              label="Document Type" dense outlined></v-select>
          </v-col>
          <v-col cols="5" md="5" sm="12">
            <v-file-input outlined dense filled v-model="addData.document" prepend-icon="mdi-paperclip"
              label="Please relevant document"></v-file-input>
          </v-col>
          <v-col cols="1" md="1" sm="12">
            <v-btn large color="green" depressed :disabled="loading || !addData.comments || !addData.document" block
              @click="add()">Add</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <DocumentList :documents="documents" :projectStatus="projectStatus" @deleteDocument="deleteDocument($event)">
            </DocumentList>
          </v-col>
        </v-row>
      </v-form>

      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" class="white--text" depressed :disabled="loading" block
              @click="previous()">Previous</v-btn>
          </v-col>
          <v-col cols="12" md="6" xs="6">
            <v-checkbox v-if="(projectStatus == 'PENDING' || projectStatus == 'PROCESSING')" v-model="submitReview"
              :label="`Confirm and submit to approval, (Please note: you can't change after submission)`"></v-checkbox>
          </v-col>

          <v-col cols="12" md="3" xs="6" v-if="submitReview">
            <v-btn class="white--text" v-if="(projectStatus == 'PENDING' || projectStatus == 'PROCESSING')" large
              color="red" depressed :disabled="loading || !submitReview" block @click="submit()">Submit</v-btn>
            <v-chip v-else>{{ projectStatus }}</v-chip>
          </v-col>
          <v-col cols="12" md="3" xs="6" v-else>
            <v-btn class="white--text" large color="blue" depressed :disabled="loading" block @click="preview()">Preview
              Draft</v-btn>

          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="successMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="closeSnackbar" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import DocumentList from "../create/child/DocumentList";
import { ProjectService } from "../../../../services/project-service.js";
import { CommonService } from "../../../../services/common-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",
  props: ["uuid"],
  components: { Alert, Snackbars, DocumentList },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    addData: {
      comments: null,
      document: null,
    },

    submitReview: false,
    documents: [],
    documentTypes: [
      {
        id: "Photo 01",
        name: "Photo 01",
      },
      {
        id: "Photo 02",
        name: "Photo 02",
      },
      {
        id: "Photo 03",
        name: "Photo 03",
      },
      {
        id: "Photo 04",
        name: "Photo 04",
      },
      {
        id: "Project Cost Bill",
        name: "Project Cost Bill",
      },
      {
        id: "Project Report",
        name: "Project Report",
      },
      {
        id: "Attendance Sheets",
        name: "Attendance Sheets",
      },
      {
        id: "Electronic media",
        name: "Electronic media",
      },
      {
        id: "Social Media",
        name: "Social Media",
      },
      {
        id: "News papers",
        name: "News papers",
      },
    ],

    projectStatus: null
  }),

  mounted() {
    this.getDocumentList();
  },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      let data = { status: "SUBMITTED" };
      this.errors = null;
      ProjectService.update(this.uuid, data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            localStorage.removeItem('service_project_uuid');
            localStorage.removeItem('service_project_step');
            localStorage.removeItem('service_project_edit');
            this.$router.push({ name: 'Projects' })
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    preview() {
      this.$router.push({ name: 'ProjectInfo', params: { uuid: this.uuid } })
    },

    previous() {
      this.$router.push({ name: 'ProjectEdit', params: { step: 4, uuid: this.uuid } })
    },

    add() {
      if (this.uuid !== null) {
        let fd = new FormData();
        fd.append("document", this.addData.document);
        fd.append("comments", this.addData.comments);
        ProjectService.documentUpload(this.uuid, fd)
          .then((response) => {
            this.loading = false;
            if (response.data.status_code === 200) {
              this.getDocumentList();
              this.reset();
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    getDocumentList() {
      if (this.uuid !== null) {
        ProjectService.getProjectInfo(this.uuid)
          .then((response) => {
            this.loading = false;
            this.documents = [];
            if (response.data.data && response.data.data.documents) {
              this.documents = response.data.data.documents;
            }

            this.projectStatus = response.data.data.status;
          })
          .catch((error) => {
            this.loading = false;
            this.documents = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    deleteDocument(uuid) {
      if (uuid !== null) {
        console.log(uuid);
        CommonService.deleteDocument(uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.message === 'success') {
              this.getDocumentList();
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.addData.comments = null;
      this.addData.document = null;
    },
  },
};
</script>
